module.exports = __webpack_public_path__ + "static/media/productIntroForm6.9d05b1be.jpg";